import React from 'react';
import DestinationTemplate from '../../components/DestinationTemplate';

const IndiaPage = () => {
  return <DestinationTemplate destinationId="india" />;
};

export default IndiaPage;
